import { Action, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { HabitatInsightsGeoJson } from 'src/shared/types';

export type HabitatInsightsGeoJsonValidationError = {
    type: string;
    message: string;
};

export type HabitatInsightsUploadFormState = {
    runCloudJobs: boolean;
    // Basic information
    customerId: string;
    customerName?: string;
    projectId: string;
    portfolioId?: string;
    projectName?: string;
    projectCode?: string;
    subscriptionType?: string;
    isHlcaProject?: boolean;
    country?: string;
    area?: string;
    publishDate?: string;
    leadName?: string;
    leadRole?: string;
    leadEmail?: string;
    // Survey samples
    uploadedFileContent: string;
    uploadedFileErrors: HabitatInsightsGeoJsonValidationError[] | [];
    uploadedFileName: string;
    sites: HabitatInsightsGeoJson[] | [];
    formMode: string;
    loading: boolean;
};

export const defaultHabitatInsightsUploadFormState = {
    runCloudJobs: true,
    customerId: '',
    customerName: '',
    projectId: '',
    portfolioId: '',
    projectName: '',
    projectCode: '',
    publishDate: '',
    subscriptionType: '',
    isHlcaProject: undefined,
    country: '',
    leadEmail: '',
    leadName: '',
    leadRole: '',
    uploadedFileContent: '',
    uploadedFileErrors: [],
    uploadedFileName: '',
    sites: [],
    formMode: 'create',
    loading: false,
};

export type HabitatInsightsUploadFormUIState = {
    formStep: number;
    formState: HabitatInsightsUploadFormState;
};

type HabitatInsightsUploadState = {
    uiState: HabitatInsightsUploadFormUIState;
};

const initialState: HabitatInsightsUploadState = {
    uiState: { formStep: 0, formState: { ...defaultHabitatInsightsUploadFormState } },
};

export const resetHabitatInsightsUpload = (): ThunkAction<void, RootState, void, Action<string>> => dispatch => {
    dispatch(habitatInsightsUploadSlice.actions.reset());
};

const habitatInsightsUploadSlice = createSlice({
    name: 'habitatInsightsUpload',
    initialState,
    reducers: {
        setCurrentStep(state, action: PayloadAction<number>) {
            state.uiState.formStep = action.payload;
        },
        setFormState(state, action: PayloadAction<Partial<HabitatInsightsUploadFormState>>) {
            state.uiState.formState = { ...state.uiState.formState, ...action.payload };
        },

        reset(state) {
            // eslint-disable-next-line
            state.uiState = { ...initialState.uiState };
        },
    },
});

export default habitatInsightsUploadSlice.reducer;

export const { setFormState, setCurrentStep, reset } = habitatInsightsUploadSlice.actions;
